export default __webpack_public_path__ + "static/media/ods.7f5838b9.svg";